import { Modal } from 'antd'
import MRNLinesForm from '../../../../components/HSEQ/MRN/Lines/MRNLinesForm'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import React from 'react'

function MRNLinesModal(props) {
  const { remove, submit, update, visible, modalType, formRef, onCancel, removing, submitting, isUpdatable } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'MRN Lines'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={isUpdatable}
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <MRNLinesForm ref={formRef} {...props} />
    </Modal>
  )
}

MRNLinesModal.propTypes = {}
MRNLinesModal.defaultProps = {}

export default MRNLinesModal
